import { z } from 'zod';

import { PrimaryKeySchema } from './utils';

export const SuggestedSearchSchema = z.object({
  query: z.string(),
});

export type SuggestedSearch = z.infer<typeof SuggestedSearchSchema>;

export const SuggestedSearchesSchema = z.array(SuggestedSearchSchema);

export type SuggestedSearches = z.infer<typeof SuggestedSearchesSchema>;

export const SuggestedSearchesQuerySchema = z.object({
  query: z.string().trim(),
  teamId: PrimaryKeySchema,
  projectId: PrimaryKeySchema,
});

export type SuggestedSearchesQuery = z.infer<
  typeof SuggestedSearchesQuerySchema
>;
